import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'cdn-icon',
    templateUrl: 'cdn-icon.html',
    styleUrls: ['cdn-icon.scss'],
    standalone: true
})
export class cdnIconComponent {

    @Input() src: string;

    constructor(
        public utils: UtilsService
    ) { }

    assembleIconLink(assetPath: string): string {
        return this.utils.getCDNAsset('icon/' + assetPath);
    }
}